import { render, staticRenderFns } from "./TelInfoView.vue?vue&type=template&id=5a79c2e8&scoped=true"
import script from "./TelInfoView.vue?vue&type=script&lang=js"
export * from "./TelInfoView.vue?vue&type=script&lang=js"
import style0 from "./TelInfoView.vue?vue&type=style&index=0&id=5a79c2e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79c2e8",
  null
  
)

export default component.exports